import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-conteudos {
  background-color: #fbfbfb;
  padding-top: 32px;
  padding-bottom: 40px;
}

#bens-servicos-conteudos .is-desk {
  display: none;
}

#bens-servicos-conteudos .is-mobi {
  overflow: hidden;
}

#bens-servicos-conteudos .ctn-home-24 {
  position: relative;
}

#bens-servicos-conteudos .bens-servicos-conteudos-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin-bottom: 16px;
}

#bens-servicos-conteudos .bens-servicos-conteudos-slide {
  display: flex;
  justify-content: center;
  margin-right: 16px;
  margin-left: 0;
  flex: 0 0 272px;
}

#bens-servicos-conteudos .bens-servicos-conteudos-card {
  display: flex;
  flex-direction: column;
  color: #fff;
  width: 272px;
  min-height: 348px;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #CCC;
}

#bens-servicos-conteudos picture {
  width: 100%;
}

#bens-servicos-conteudos img {
  width: 100%;
  height: 189px;
  object-fit: cover;
  border-radius: 4px;
}

#bens-servicos-conteudos .bens-servicos-conteudos-card-textos {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 160px;
  padding: 8px 16px 11px;
}

#bens-servicos-conteudos .bens-servicos-conteudos-slide-titulo {
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  margin: 0;
  text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}

#bens-servicos-conteudos .bens-servicos-conteudos-slide-link {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

#bens-servicos-conteudos .custom-carousel.embla {
  margin-bottom: 18px;
}


#bens-servicos-conteudos .home-pagination {
  width: 100%;
  max-width: 288px;
  margin-left: auto;
  margin-right: auto;
}

#bens-servicos-conteudos .home-pagination .enable-mobile-arrows {
  height: 24px;
  width: 24px;
  background-size: 24px 24px;
}

@media (min-width: 992px) {

  #bens-servicos-conteudos { 
    padding-top: 88px;
    padding-bottom: 88px;
  }

  #bens-servicos-conteudos .is-mobi {
    display: none;
  }

  #bens-servicos-conteudos .is-desk {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: auto;
  }

  #bens-servicos-conteudos .cards-desk {
    display: flex;
    justify-content: space-between;
  }

  #bens-servicos-conteudos .bens-servicos-conteudos-card {
    width: 100%;
    max-width: 379px;
  }

  #bens-servicos-conteudos .bens-servicos-conteudos-card-textos {
    padding: 8px 16px 32px;
    height: 178px;
  }

}`;

export default styles;